// pages/Settings.tsx

import React from 'react';

const Settings = () => {
    const token = localStorage.getItem('token');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const taxSettings = JSON.parse(localStorage.getItem('taxsettings') || '[]');
    const generalSettings = JSON.parse(localStorage.getItem('settings') || '[]');

    /*
    {
    "id": 10,
    "vendorId": 4,
    "currencyName": "RM",
    "currencySymbol": "MYR",
    "supportsOrderType": 1,
    "redirectAfterOrder": "orderDetail.html",
    "showAlerts": "{\"showOrderTypeAlert\":false,\"showTableSelectionAlert\":false,\"showOrderPlacedAlert\":false,\"showLeaveReorderConfirm\":false}",
    "officeHourStart": "09:00:00",
    "officeHourEnd": "02:00:00",
    "selectedTemplateId": 1,
    "officeName": "Demo Shop",
    "officeAddress": "Demo Address",
    "createdAt": "2024-08-09T04:40:18.000Z",
    "updatedAt": "2024-10-12T15:13:38.000Z"
}
    */
    
    // Render JSON data with nested handling for better readability
    const renderJSON = (data: any) => {
        if (Array.isArray(data)) {
            return data.map((item, index) => (
                <div key={index} className="ml-4">
                    <p><strong>Item {index + 1}:</strong></p>
                    {renderJSON(item)}
                </div>
            ));
        } else if (typeof data === 'object' && data !== null) {
            return Object.entries(data).map(([key, value]) => (
                <p key={key} className="ml-4"><strong>{key}:</strong> {JSON.stringify(value)}</p>
            ));
        }
        return <p>{data}</p>;
    };

    return (
        <div className="app-page p-6">
            <h1 className="text-2xl font-bold mb-4">Settings</h1>

            {/* Token Section */}
            <section className="mb-6">
                <h2 className="text-xl font-semibold">Authentication</h2>
                <p><strong>Token:</strong> {token || 'Not available'}</p>
            </section>

            {/* User Section */}
            <section className="mb-6">
                <h2 className="text-xl font-semibold">User Information</h2>
                {user && Object.keys(user).length > 0 ? (
                    <div>{renderJSON(user)}</div>
                ) : (
                    <p>User data not available</p>
                )}
            </section>

            {/* Tax Settings Section */}
            <section className="mb-6">
                <h2 className="text-xl font-semibold">Tax Settings</h2>
                {taxSettings && taxSettings.length > 0 ? (
                    taxSettings.map((tax: any, index: number) => (
                        <div key={index} className="mb-2">
                            <h3 className="text-lg font-semibold">Tax {index + 1}</h3>
                            {renderJSON(tax)}
                        </div>
                    ))
                ) : (
                    <p>Tax settings not available</p>
                )}
            </section>

            {/* General Settings Section */}
            <section>
                <h2 className="text-xl font-semibold">General Settings</h2>
                {generalSettings && generalSettings.length > 0 ? (
                    generalSettings.map((setting: any, index: number) => (
                        <div key={index} className="mb-2">
                            <h3 className="text-lg font-semibold">Setting {index + 1}</h3>
                            {renderJSON(setting)}
                        </div>
                    ))
                ) : (
                    <p>General settings not available</p>
                )}
            </section>
        </div>
    );
};

export default Settings;
